"use client";
import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./HealthSolutions.css";
import BlueSectionDivider from "./BlueSectionDivider";
import {Link} from 'react-router-dom';

const stats = [
  { value: "+90", label: "Specialists" },
  { value: "+20", label: "Industry sectors" },
  { value: "78", label: "Customer NPS Score" },
  { value: "99%", label: "Recommendation Rate" },
  { value: "+300", label: "Projects delivered" }
];

const cards = [
  {
    icon: <img src="/icons/hospital.webp" alt="Hospital" />,
    title: "HOSPITALS",
    desc: "Utilize telemedicine and remote patient monitoring alongside cutting-edge AI in diagnostics to facilitate efficient clinical decision-making, streamline operations, and ultimately improve patient outcomes."
  },
  {
    icon: <img src="/icons/clinics.webp" alt="Clinics" />,
    title: "CLINICS",
    desc: "Leverage digital health records, telehealth services, and patient engagement platforms to provide personalized and accessible healthcare. Embrace wearables and analytics to enhance your diagnostic capabilities."
  },
  {
    icon: <img src="/icons/home.webp" alt="Home Healthcare" />,
    title: "HOME HEALTHCARE",
    desc: "Offer virtual consultations through telehealth services, streamline information access with advanced Electronic Health Records (EHR/EMR), and support continuous monitoring with wearables. These solutions will enhance the delivery of your primary care services."
  },
  {
    icon: <img src="/icons/diagnostic.webp" alt="Diagnostic Imaging" />,
    title: "DIAGNOSTIC IMAGING CENTERS",
    desc: "In your diagnostic imaging center, harness the power of AI in diagnostics and digital health records to improve the accuracy and efficiency of medical imaging interpretation."
  },
  {
    icon: <img src="/icons/mental.webp" alt="Mental Health" />,
    title: "MENTAL HEALTH CLINICS",
    desc: "Prioritize accessible care in your mental health clinic with telehealth services and digital therapeutics. Utilize patient engagement platforms for ongoing communication and mHealth apps for mental health tracking and intervention."
  },
  {
    icon: <img src="/icons/medical.webp" alt="Medical Training" />,
    title: "MEDICAL TRAINING INSTITUTIONS",
    desc: "Revolutionize education in your medical training institution through MedTech’s augmented and virtual reality applications. Utilize clinical decision support systems for teaching, and preparing healthcare professionals for the digital future of medicine."
  }
];

export default function HealthSolutionsSection() {
  const [active, setActive] = useState("solutions");

  const sectionsToHighlight = [
    "solutions",
    "benefits",
    "tech stack",
    "faq",
    "contact us"
  ];

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const offset = 80;
      const scrollY = window.scrollY + offset;

      for (let i = sectionsToHighlight.length - 1; i >= 0; i--) {
        const section = document.getElementById(sectionsToHighlight[i]);
        if (section && section.offsetTop <= scrollY) {
          setActive(sectionsToHighlight[i]);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = (id) => {
    setActive(id);
    const section = document.getElementById(id);
    section?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      {/* Sticky Navbar */}
      <div className="health-navbar">
        <div className="container">
          <ul>
            {sectionsToHighlight.map((item) => (
              <li key={item}>
                <a
                  onClick={() => handleClick(item)}
                  className={active === item ? "active" : ""}
                >
                  {item.toUpperCase()}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Section Content */}
      <section className="health-section" id="solutions">
        <div className="container">
        <div className="health-stats-row" data-aos="fade-up">
          {stats.map((stat, i) => (
            <div className="health-stat" key={i}>
              <div className="health-stat-value">{stat.value}</div>
              <div className="health-stat-label">{stat.label}</div>
            </div>
          ))}
          <BlueSectionDivider />
        </div>

        <div className="health-title-group" data-aos="fade-up">
          <div className="health-title">DIGITAL SOLUTIONS</div>
          <div className="health-title-blue">FOR THE DIFFERENT HEALTHCARE AREAS</div>
        </div>

        <div className="health-cards-grid">
          {cards.map((card, i) => (
            <div
              className="health-card"
              key={i}
              data-aos="fade-up"
              data-aos-delay={100 + i * 100}
            >
              <div className="health-card-icon">{card.icon}</div>
              <div className="health-card-title">{card.title}</div>
              <div className="health-card-desc">{card.desc}</div>
            </div>
          ))}
        </div>

        <div className="health-cta-row" data-aos="fade-up" data-aos-delay="600">
          <button className="health-cta-btn">
            <Link to="/contact">
            GET STARTED WITH YOUR HEALTHTECH DIGITAL PRODUCT
            </Link>
          </button>
        </div>
        </div>
      </section>
    </>
  );
}
